import React from 'react';
import { getFormatedDate, injectImageResolution, getMediaHost, pathJoin, get } from '../../utils';
import { Link as RouterLink } from 'react-router-dom';
import LazyPicture from '../atoms/LazyPicture';
import { convertToAnalyticObject } from '../../utils/analytics';

// import IconChevronLeftLight from '../../resources/icons/IconChevronLeftLight.svg';
// import IconChevronRightLight from '../../resources/icons/IconChevronRightLight.svg';

import { tealiumMergeClickData, tealiumClickFunc, getLastPartInURL } from '../../utils/tealium';
import { IconChevronLeft, IconChevronRight } from '../atoms/Icons';
var FeaturedResultItem = /*#__PURE__*/React.memo(function (_ref) {
  var item = _ref.item,
    rtl = _ref.rtl,
    readFeaturedLabel = _ref.readFeaturedLabel,
    language = _ref.language,
    analytics = _ref.analytics;
  var url = item.url;
  var data = analytics.data,
    params = analytics.params;
  var englishTitleforAnalytics = get(item, '_highlightResult.englishtitle.value', '') || '';
  var eventsAnalytics = get(analytics, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderImage = function renderImage() {
    if (!item.headerimage) return null;
    var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), item.headerimage.src])), 460, 460);
    var linkText = item.headerimage.alt || " ";
    return /*#__PURE__*/React.createElement(RouterLink, {
      "aria-label": linkText,
      to: url,
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(data.featuredBannerClickAnalytics, params), getLastPartInURL(url));
      }
    }, /*#__PURE__*/React.createElement(LazyPicture, {
      className: "news-featured__media-container"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 991px)",
      srcSet: imgSrc
    }), /*#__PURE__*/React.createElement("img", {
      className: "news-featured__media-img",
      src: imgSrc,
      alt: linkText
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "news-featured__block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-5 col-lg-4"
  }, renderImage()), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 offset-md-1 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "news-featured__info-container"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "news__info-label-cnt"
  }, /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.category), /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, getFormatedDate((item.dateofissue || item.__updated) * 1000, language)), item.location && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.location.city + ', ' + item.location.country)), /*#__PURE__*/React.createElement("div", {
    className: "news__author"
  }, item.author), /*#__PURE__*/React.createElement(RouterLink, {
    to: url,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["featuredTitleClickAnalytics"], params), englishTitleforAnalytics);
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "h3 news-featured__title"
  }, item.pagetitle)), /*#__PURE__*/React.createElement("p", {
    className: "news-featured__para"
  }, item.pageintro), /*#__PURE__*/React.createElement("div", {
    className: "news-featured__read-row d-md-block"
  }, readFeaturedLabel && /*#__PURE__*/React.createElement("div", {
    className: "btn-tertiary news-featured__read-link"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary__text",
    to: url,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["featuredReadMoreAnalytics"], params), englishTitleforAnalytics);
    },
    "aria-label": "".concat(item.pagetitle, " | ").concat(readFeaturedLabel.value)
  }, readFeaturedLabel.value, rtl ? /*#__PURE__*/React.createElement(IconChevronLeft, {
    className: "btn-tertiary__icon"
  }) : /*#__PURE__*/React.createElement(IconChevronRight, {
    className: "quick-links__icon"
  }))))))));
});
export default FeaturedResultItem;